import React from "react";
import Img from 'gatsby-image';
import { Helmet } from 'react-helmet';
import styles from './journey.module.css';
import Journey from '../components/journey';
import Email from '../components/email';

export default ({ data }) => {
  const page = data.page;
  const journeys = data.journeys.edges.map(edge =>
    <Journey data={edge.node} />
  );
  return (
    <main>
      <Helmet title={page.frontmatter.title + ' - Quo Vadis Journeys'} />
      <div className={styles.header} >
        <Img
          className={styles.background}
          outerWrapperClassName={styles.background}
          sizes={page.frontmatter.image.childImageSharp.sizes}
          />
        <div className={styles.titleDiv}>
          <h1 className={styles.title}>{page.frontmatter.title}</h1>
          <h2>{page.frontmatter.dates}</h2>
        </div>
      </div>
      <div className={styles.text} dangerouslySetInnerHTML={{ __html: page.html }} />
      {page.frontmatter.journeys == 'pilgrimages'
        ? <section>
          <h1 style={{'text-align': 'center', 'margin': 20}} >
            Upcoming Pilgrimages
          </h1>
          {journeys}
          </section>
        : null
      }
      <Email />
    </main>
  );
};

export const query = graphql`
  query PageQuery($slug: String!) {
    journeys: allMarkdownRemark(
      filter: { fields: { slug: { regex: "/journeys/" } } }
    ) {
      edges {
        node {
          fields {
            slug
          }
          frontmatter {
            title
            dates
            startDate
            image {
              childImageSharp {
                resolutions(width: 1920) {
                  ...GatsbyImageSharpResolutions
                }
              }
            }
          }
        }
      }
    }
    page: markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
        journeys
        image {
          childImageSharp {
            sizes(maxWidth: 1920) {
              ...GatsbyImageSharpSizes
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/page.js